import { FC, useEffect } from 'react'
import { Flex, Layout as AntdLayout, Button } from 'antd'
import { Link, useNavigate } from 'react-router'
import { useOktaAuth } from '@okta/okta-react'
import { Title } from '@signifyd/components'
import styles from './SignedOut.less'

const SignedOutPage: FC = () => {
  const { oktaAuth, authState } = useOktaAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (authState?.isAuthenticated) {
      void navigate('/playwright', { replace: true })
    } else if (authState) {
      // Used for removing the query params upon sign out
      void navigate('/login', { replace: true })
    }
  }, [authState, navigate])

  const { Header, Content, Footer } = AntdLayout

  return (
    <AntdLayout className={styles.layout}>
      <Header style={{ backgroundColor: 'black' }}>
        <Flex justify="space-between" align="center">
          <Link className={styles.buttonText} to="/playwright">
            Playwright Dashboard
          </Link>
          <div>
            <Button
              type="link"
              className={styles.buttonText}
              onClick={() => oktaAuth.signInWithRedirect({})}
            >
              Log in
            </Button>
          </div>
        </Flex>
      </Header>
      <Content>
        <Flex justify="center" align="center" className={styles.pageContent}>
          <Title>
            You are currently signed out. Please sign in to continue
          </Title>
        </Flex>
      </Content>
      <Footer className={styles.footer}>Signifyd</Footer>
    </AntdLayout>
  )
}

export default SignedOutPage
